import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller'
import Loader from 'components/Loader'
import { Container, Table, Button, Header } from 'semantic-ui-react'
import { Query, Mutation } from 'react-apollo'
import gql from 'graphql-tag'

class Tips extends Component {
  state = {
    limit: 20,
    offset: 0,
    hasMore: true,
  }

  render() {
    const { limit, offset, hasMore } = this.state
    const variables = { limit, offset }

    return (
      <Container>
        <Header as="h1">Today's Tip</Header>
        <div>
          <Button
            floated="right"
            primary
            size="small"
            content="Add Tip"
            onClick={() => this.props.history.push('/tips/new')}
          />
        </div>

        <Query query={TIPS_QUERY} variables={variables}>
          {({ data, loading, error, fetchMore }) => {
            if (loading) {
              return <Loader />
            }

            return (
              <Table>
                <InfiniteScroll
                  loadMore={() =>
                    fetchMore({
                      variables: { offset: data.tips.length },
                      updateQuery: (prev, { fetchMoreResult, variables }) => {
                        if (!fetchMoreResult) return prev
                        if (!fetchMoreResult.tips.length) {
                          this.setState({ hasMore: false })
                        }
                        return {
                          ...prev,
                          tips: [...prev.tips, ...fetchMoreResult.tips],
                        }
                      },
                    })
                  }
                  hasMore={hasMore}
                  loader={<Loader />}
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Info</Table.HeaderCell>
                      <Table.HeaderCell>Published</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {data.tips.map(tip => (
                      <Table.Row key={tip.id}>
                        <Table.Cell width={8}>{tip.info}</Table.Cell>
                        <Table.Cell width={4}>{String(tip.active)}</Table.Cell>
                        <Table.Cell width={4}>
                          <div style={{ display: 'flex' }}>
                            <Link to={`/tips/edit/${tip.id}`}>
                              <Button basic color="blue" content="Edit" />
                            </Link>
                            <Mutation
                              mutation={PUBLISH_TIP}
                              update={(cache, { data: { updateTip } }) => {
                                const { tips } = cache.readQuery({
                                  query: TIPS_QUERY,
                                  variables,
                                })
                                const indexToUpdate = tips.findIndex(
                                  t => t.id === tip.id,
                                )
                                const data = {
                                  tips: [
                                    ...tips.slice(0, indexToUpdate),
                                    {
                                      ...updateTip,
                                      active: !tip.active,
                                    },
                                    ...tips.slice(indexToUpdate + 1),
                                  ],
                                }
                                cache.writeQuery({
                                  query: TIPS_QUERY,
                                  data,
                                  variables,
                                })
                              }}
                            >
                              {(updateTip, { data, loading, error }) => {
                                return (
                                  <Button
                                    basic
                                    loading={loading}
                                    color="orange"
                                    style={{
                                      width: '100%',
                                    }}
                                    content={
                                      tip.active ? 'Unpublish' : 'Publish'
                                    }
                                    onClick={async () =>
                                      await updateTip({
                                        variables: {
                                          id: tip.id,
                                          input: {
                                            active: !tip.active,
                                          },
                                        },
                                      })
                                    }
                                  />
                                )
                              }}
                            </Mutation>
                            <Mutation
                              mutation={DELETE_TIP}
                              update={cache => {
                                const { tips } = cache.readQuery({
                                  query: TIPS_QUERY,
                                  variables,
                                })
                                const data = {
                                  tips: tips.filter(t => t.id !== tip.id),
                                }
                                cache.writeQuery({
                                  query: TIPS_QUERY,
                                  data,
                                  variables,
                                })
                              }}
                            >
                              {(deleteTip, { data }) => {
                                return (
                                  <Button
                                    basic
                                    color="red"
                                    content="Delete"
                                    onClick={async () => {
                                      await deleteTip({
                                        variables: {
                                          id: tip.id,
                                        },
                                      })
                                    }}
                                  />
                                )
                              }}
                            </Mutation>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </InfiniteScroll>
              </Table>
            )
          }}
        </Query>
      </Container>
    )
  }
}

export const TIPS_QUERY = gql`
  query TipsQuery($limit: Int, $offset: Int) {
    tips(limit: $limit, offset: $offset) {
      id
      info
      active
      created
      updated
    }
  }
`

const PUBLISH_TIP = gql`
  mutation UpdateTip($id: ID!, $input: UpdateTipInput!) {
    updateTip(id: $id, input: $input) {
      id
      info
      active
    }
  }
`

const DELETE_TIP = gql`
  mutation DeleteTip($id: ID) {
    deleteTip(id: $id) {
      id
    }
  }
`
export default Tips
